import styled, { css } from "styled-components";
import { Navbar } from "react-bootstrap";

export const HeaderNav = styled(Navbar)`
  ${({ theme, company }) => css`
    position: fixed;
    padding-top: 10px;
    padding-left: 250px;
    width: 100%;
    height: 70px;
    top: 0;
    z-index: 2;
    background-color: #f7f7f7;
    background-color: ${company === "which"
      ? theme.colors.whichHeader
      : company === "coco_direct"
      ? theme.colors.cocoheader
      : "#F7F7F7"};
  `}
  @media only screen and (max-width: 767px) {
    padding-left: 20px;
  }
`;
